module.exports = __webpack_public_path__ + "img/bildergalerie.b589b3e3.svg";